<mat-card class="usage-card">
  <div class="card-container">
    <h3 class="card-title">{{ title }}</h3>

    <div class="content-row">
      <!-- SVG Диаграмма -->
      <div class="chart-section">
        <svg viewBox="0 0 240 240" class="donut-svg">
          @for (segment of stats().segments; track $index) {
            <path
              [attr.d]="describeArc(120, 120, 60, segment.startAngle, segment.endAngle)"
              [attr.stroke]="segment.color"
              stroke-width="20"
              fill="none"
              stroke-linecap="round"
            />
          }

          <!-- Центр: процент -->
          <text
            x="120"
            y="120"
            text-anchor="middle"
            dominant-baseline="central"
            class="center-label"
          >
            {{ stats().pct | number: '1.1-1' }}%
          </text>
        </svg>
      </div>

      <!-- Легенда -->
      <div class="legend-section">
        <!-- Распределено -->
        <div class="legend-row">
          <div class="legend-label">
            <span class="legend-dot" [style.background]="C_ALLOCATED"></span>
            <span>{{ 'dashboard.allocated' | translate }}</span>
          </div>
          <div class="legend-value">
            {{ stats().allocatedTons }} {{ 'dashboard.tons' | translate | lowercase }}
          </div>
        </div>

        <!-- Использовано -->
        <div class="legend-row">
          <div class="legend-label">
            <span class="legend-dot" [style.background]="C_USED"></span>
            <span>{{ 'dashboard.used' | translate }}</span>
          </div>
          <div class="legend-value">
            {{ stats().pct | number: '1.1-1' }} %
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
